declare global {
  interface String {
    formatDatetimeStrToNaijaTime(): string;
    replaceZeroWith234(): string;
    capitalize(): string;
  }
  interface Number {
    formatNaira(): string;
  }
}

// eslint-disable-next-line
Number.prototype.formatNaira = function (): string {
  return this.toLocaleString('en-NG', {
    style: 'currency',
    currency: 'NGN',
  });
};

// eslint-disable-next-line
String.prototype.formatDatetimeStrToNaijaTime = function (): string {
  const date = new Date(this as string);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: 'Africa/Lagos',
  } as Intl.DateTimeFormatOptions;

  return date.toLocaleString('en-NG', options);
};

// eslint-disable-next-line
String.prototype.replaceZeroWith234 = function (): string {
  if (this.startsWith('0')) {
    return '234' + this.slice(1);
  }
  return this.toString();
};

// eslint-disable-next-line
String.prototype.capitalize = function (): string {
  if (this.length === 0) {
    return this.toString();
  }
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

export {};
